/* global $ */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import * as XLSX from "xlsx";
import axios from 'axios';
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import axiosInstance from '../axiosInstance';


function FullSettlement() {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from;

    const [existingData, setexistingData] = useState(null);
    const [editData, seteditData] = useState(null);
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);

    const [newRecord, setNewRecord] = useState({
        id: "",
        reg_no: "",
        recipient_name: "",
        recipient_city: "",
        finance_date: "",
        next_due_date: "",
        loan_amount: "",
        paid_loanamount: "",
        balance_loanamount: "",
        totaldue_count: "",
        paiddue_count: "",
        balancedue_count: "",
        noofdue: "",
        principal: "",
        interest: "",
        due_day: "",
        due_no: "",
        emi_amount: "",
        previous_due_balance: "",
        penalty_perday: "",
        penalty: "",
        penalty_paid: "",
        penalty_balance: "",
        late_fine: "",
        late_fine_paid: "",
        late_fine_balance: "",
        due_amount: "",
        due_amount_paid: "",
        due_amount_balance: "",
        total: "",
        payment_type: "",
        remark: "",

        balance_amount: "",
        balance_principal: "",
        balance_interest: "",
        closure_fine_amount: "",
        closure_amount: "",
        closure_type: "",
        closure_date: "",
    });

    const [errors, setErrors] = useState({
        balance_amount: "",
        principal: "",
        interest: "",
        due_amount: "",
        total: "",
        payment_type: ""
    });
    const [registrations, setRegistrations] = useState([]);

    useEffect(() => {
        const data = location.state?.row;
        setexistingData(data);
    }, [location.state]);

    useEffect(() => {
        if (existingData) {
            const financeId = existingData.id;

            const fetchPreviousDetails = async () => {
                try {
                    const response = await axiosInstance.get(`/receipt/previousdetails/${financeId}`);
                    console.log("freshapidataresponse: ", response)
                    console.log("freshapidata: ", response.data)
                    const fineBalance = Number(existingData.fine_balance);
                    const calculatedFine = Number(response.data.calculated_fine);
                    const newValues = {
                        id: existingData.id,
                        reg_no: existingData.reg_no,
                        recipient_name: existingData.borrower_name,
                        recipient_city: existingData.borrower_city,
                        finance_date: existingData.date,
                        next_due_date: response.data.due_date,
                        loan_amount: existingData.loan_amount,
                        paid_loanamount: response.data.totalpaiddue,
                        balance_loanamount: response.data.totalbalancedue,
                        totaldue_count: response.data.totalduecount,
                        paiddue_count: response.data.due_receipt_count,
                        balancedue_count: response.data.balanceduecount,
                        principal: existingData.principal_amount,
                        interest: existingData.interest_amount,
                        due_day: existingData.due_date,
                        due_no: response.data.due_no,
                        emi_amount: existingData.emi_amount,
                        previous_due_balance: existingData.due_balance,
                        penalty_perday: existingData.penalty_perday,
                        penalty: response.data.penalty,
                        late_fine: existingData.fine_balance,
                        late_fine_paid: (fineBalance > 0)
                            ? fineBalance
                            : (calculatedFine > 0 ? calculatedFine : 0),

                        balance_amount: response.data.totalbalancedue,
                        balance_principal: existingData.principal_amount * response.data.balanceduecount,
                        balance_interest: existingData.interest_amount * response.data.balanceduecount,
                        closure_fine_amount: existingData.fine_balance,
                        closure_amount: response.data.totalbalancedue + existingData.fine_balance,
                    };

                    // Compute total from latest fetched values
                    const total =
                        (parseFloat(newValues.due_amount) || 0) +
                        (parseFloat(newValues.penalty) || 0) +
                        (parseFloat(newValues.late_fine) || 0);

                    setNewRecord({
                        ...newValues,
                        total: total
                    });

                } catch (error) {
                    console.error('Error fetching previous data:', error);
                }
            };

            fetchPreviousDetails();
        }
    }, [existingData]);


    useEffect(() => {
        const fetchRegistrationData = async () => {
            try {
                const endpoint = existingData
                    ? '/dealer/listforbilling'
                    : '/dealer/listforfinance';
                console.log("endpoint:", endpoint)
                const response = await axiosInstance.get(endpoint);
                console.log("Registration data : ", response)
                setRegistrations(response.data);

                if (existingData) {
                    setNewRecord({
                        ...existingData
                    });
                }
            } catch (error) {
                console.error('Error fetching registration data:', error);
                setRegistrations([]);
            }
        };

        fetchRegistrationData();
    }, [existingData]);


    // Validation function
    const validateForm = () => {
        let formErrors = {}; // Store validation errors

        // Check if required fields are empty (if a field is required, you can add custom logic here)
        
        if (!newRecord.closure_type) {
            formErrors.closure_type = "Closure Type is required";
        }

        if (!newRecord.closure_date) {
            formErrors.closure_date = "Closure Date Amount is required";
        }

        // If there are errors, set them in the state and return false
        if (Object.keys(formErrors).length > 0) {
            setErrors(formErrors); // Store the errors in the state
            return false; // Validation failed
        }

        // Return true if no errors
        return true;
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Form submitted");
        if (validateForm()) {
            setErrors({});
            setLoading(true);

            try {
                const result = await Swal.fire({
                    title: 'Are you sure?',
                    text: "Do you want to Close the Finance?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Close it!'
                });

                if (result.isConfirmed) {
                    const modified_by = localStorage.getItem('user_id');

                    const updatedData = {
                        isclosed: true,
                        balance_amount: newRecord.balance_amount,
                        balance_principal: newRecord.balance_principal,
                        balance_interest: newRecord.balance_interest,
                        closure_fine_amount: newRecord.closure_fine_amount,
                        closure_amount: newRecord.closure_amount,
                        closure_type: newRecord.closure_type,
                        closure_date: newRecord.closure_date,
                        loan_remark: newRecord.remark,
                        modified_by: modified_by,
                    };

                    await axiosInstance.put(`/finance/${existingData.id}`, updatedData, {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    });

                    Swal.fire('Updated!', 'The Finance record has been updated.', 'success');
                    navigate('/finance');
                }

            } catch (error) {
                console.error('Error saving receipt:', error);
                const errorMessage = error.response?.data?.error || error.response?.data?.message || error.response?.statusText || 'An unknown error occurred';
                Swal.fire('Error!', `There was an issue closing the finance record: ${errorMessage}`, 'error');
            } finally {
                setLoading(false);
            }
        }
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        let updatedRecord = {
            ...newRecord,
            [name]: value
        };
        // Only auto-calculate closure_amount if balance_amount or closure_fine_amount changed
        if (name === 'balance_amount' || name === 'closure_fine_amount') {
            const balanceAmount = name === 'balance_amount' ? parseFloat(value) : parseFloat(updatedRecord.balance_amount);
            const fineAmount = name === 'closure_fine_amount' ? parseFloat(value) : parseFloat(updatedRecord.closure_fine_amount);

            updatedRecord.closure_amount = (balanceAmount || 0) + (fineAmount || 0);
        }

        // If the user manually edits closure_amount, accept it
        if (name === 'closure_amount') {
            updatedRecord.closure_amount = parseFloat(value) || 0;
        }

        setNewRecord(updatedRecord);
    };



    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Full Settlement</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item"><a href="/finance">Finance</a></li>
                                <li className="breadcrumb-item active">Full Settlement</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row mb-2 mt-2">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="delivery-note-info">
                                <div>
                                    <h3 className="delivery-note-fromto">Recipient Details:</h3>
                                    <p><strong>Registration No: </strong>{newRecord.reg_no || ""}</p>
                                    <p><strong>Recipient Name: </strong>{newRecord.recipient_name || ""}</p>
                                    <p><strong>Recipient City: </strong>{newRecord.recipient_city || ""}</p>
                                    <p><strong>Finance Date: </strong>{new Date(newRecord.finance_date).toLocaleDateString("en-GB") || ""}</p>
                                </div>
                                <div>
                                    <h3 className="delivery-note-fromto">Finance Details:</h3>
                                    <p><strong>Loan Amount: </strong>{newRecord.loan_amount}</p>
                                    <p><strong>Loan Amount Paid: </strong>{newRecord.paid_loanamount}</p>
                                    <p><strong>Loan Amount Balance: </strong>{newRecord.balance_amount}</p>
                                    <p><strong>EMI Amount: </strong>{newRecord.emi_amount}</p>
                                    <p><strong>Total Dues: </strong>{newRecord.totaldue_count}</p>
                                    <p><strong>Paid Dues: </strong>{newRecord.paiddue_count}</p>
                                    <p><strong>Balance Due: </strong>{newRecord.balancedue_count}</p>
                                </div>
                            </div>
                            <hr class="divider"></hr>

                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Balance Amount</label>
                                            <input type="text" name="balance_amount" value={newRecord.balance_amount} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Balance Principal</label>
                                            <input type="text" name="balance_principal" value={newRecord.balance_principal} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Balance Interest</label>
                                            <input type="text" name="balance_interest" value={newRecord.balance_interest} onChange={handleInputChange} className="form-control" readOnly />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Closure Late Fine</label>
                                            <input type="text" name="closure_fine_amount" value={newRecord.closure_fine_amount} onChange={handleInputChange} className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label>Closure Amount</label>
                                            <input type="text" name="closure_amount" value={newRecord.closure_amount} onChange={handleInputChange} className="form-control" />
                                            
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div class="form-group">
                                            <label for="closure_type">Closure Type</label>
                                            <select className="form-control select2" style={{ width: "100%" }} name="closure_type" value={newRecord.closure_type} onChange={handleInputChange} >
                                                <option value="">Select Closure Type</option>
                                                <option value="Completed">All Dues Paid</option>
                                                <option value="FullSettlement">Full Settlement</option>
                                                <option value="Seized">Vehicle Seized</option>
                                            </select>
                                            {errors.closure_type && <small className="text-danger">{errors.closure_type}</small>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label>Closure Date</label>
                                        <input type="date" className="form-control" name="closure_date" value={newRecord.closure_date} onChange={handleInputChange} />
                                        {errors.closure_date && <small className="text-danger">{errors.closure_date}</small>}
                                    </div>
                                    <div className="col-md-8 mb-3">
                                        <label>Remark</label>
                                        <textarea className="form-control" name="remark" rows="2" value={newRecord.remark} onChange={handleInputChange} placeholder="Enter remark (optional)" />
                                    </div>
                                </div>

                                <div className="modal-footer justify-content-between">
                                    <button type="submit" className="btn btn-primary">Close Finance</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default FullSettlement